// extracted by mini-css-extract-plugin
export var byline = "ContentBlockCard-module--byline--uZZj-";
export var contentBlockCard = "ContentBlockCard-module--content-block-card--KnQvd";
export var cta = "ContentBlockCard-module--cta--6Qr4C";
export var deactivated = "ContentBlockCard-module--deactivated--F+sHT";
export var description = "ContentBlockCard-module--description--Iiogn";
export var imageWrapper = "ContentBlockCard-module--image-wrapper--j8DbV";
export var textWrapper = "ContentBlockCard-module--text-wrapper--dOEp3";
export var title = "ContentBlockCard-module--title--X+ydu";